import {MeetingInterface} from "../interfaces/meetings/MeetingInterface";
import {setDates} from "../helpers/DatesSetter";
import {DateTime} from "luxon";
import {Participant} from "./Participant";
import {ParticipantInterface} from "../interfaces/meetings/ParticipantInterface";
import {ParticipantStatuses} from "../../enums/Meetings/ParticipantStatuses";

export class Meeting implements MeetingInterface {
    title?: string = undefined;
    description?: string = undefined;
    beginAt?: DateTime = undefined;
    endAt?: DateTime = undefined;
    eventId?: string = undefined;
    fileIds?: string[] = undefined;
    ownerId?: number= undefined;
    id: string;
    createdAt?: DateTime = undefined;
    updatedAt?: DateTime = undefined;
    isDeleted?: boolean = undefined;
    isPublished?: boolean = undefined;
    updatedBy?: number = undefined;
    participants: Participant[] = [];

    private dates: string[] = ['beginAt', 'endAt', 'createdAt', 'updatedAt'];

    constructor(data: MeetingInterface) {
        Object.assign(this, data);
        setDates(this, this.dates);
        if (this.participants) {
            this.participants = this.participants.map((item: ParticipantInterface) => new Participant(item));
        }
        else {
            this.participants = [];
        }
    }

    /**
     * if all participants accepted then true
     */
    isConfirmedAll(): boolean {
        return (this.participants || [])
                .reduce((accumulator: boolean, currentValue: ParticipantInterface) => {
                    return accumulator && currentValue.status?.toLowerCase() == ParticipantStatuses.accepted;
                }, true);
    }

    /**
     * if once participants(except the organizer) accepted then true
     */
    isConfirmed(): boolean {
        let count = 0;
        return (this.participants || []).some((element: ParticipantInterface) => {
            if(element.status?.toLowerCase() == ParticipantStatuses.accepted) {
                count++;
            }
            return count > 1 ; // organizer + participant
        });
    }

    /**
     * returns true if the meeeting should be live now
     */
    isNow(): boolean {
        const now = DateTime.local(),
            isNow = now >= (this.beginAt?.minus({minutes: 15}) as DateTime) &&
                    now <= (this.endAt?.plus({minutes: 15}) as DateTime);
        return isNow;
    }

    /**
     * returns true if the meeting is ended
     */
    isEnded(): boolean {
        const now = DateTime.local();

        return now >= (this.endAt?.plus({ minutes: 15 }) as DateTime)
    }
}
